import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/CustomDiceRoller/components/Roller/styles.module_built.css";
const classes = {"refreshText":"ogfxNa_refreshText","d10":"ogfxNa_d10","d20":"ogfxNa_d20","d8":"ogfxNa_d8","d4":"ogfxNa_d4","diceSetLabel":"ogfxNa_diceSetLabel","rollToActive":"ogfxNa_rollToActive","shared3dDiceImageWrapper":"ogfxNa_shared3dDiceImageWrapper","dice":"ogfxNa_dice","shared3dDiceContainer":"ogfxNa_shared3dDiceContainer","buttonsWrapper":"ogfxNa_buttonsWrapper","clearButton":"ogfxNa_clearButton","shared3dDiceImageDisabled":"ogfxNa_shared3dDiceImageDisabled","wrapper":"ogfxNa_wrapper","rollToWrapper":"ogfxNa_rollToWrapper","rollToLabel":"ogfxNa_rollToLabel","rollToContainer":"ogfxNa_rollToContainer","plus":"ogfxNa_plus","gear":"ogfxNa_gear","shared3dDiceImage":"ogfxNa_shared3dDiceImage","d100":"ogfxNa_d100","rollButton":"ogfxNa_rollButton","diceTextContainer":"ogfxNa_diceTextContainer","changeDiceSetLink":"ogfxNa_changeDiceSetLink","settingsButtonContainer":"ogfxNa_settingsButtonContainer","diceContainer":"ogfxNa_diceContainer","rollToButton":"ogfxNa_rollToButton","die":"ogfxNa_die"}
export default classes

const _refreshText0 = classes["refreshText"]
export { _refreshText0 as "refreshText" }

const _d100 = classes["d10"]
export { _d100 as "d10" }

const _d200 = classes["d20"]
export { _d200 as "d20" }

const _d80 = classes["d8"]
export { _d80 as "d8" }

const _d40 = classes["d4"]
export { _d40 as "d4" }

const _diceSetLabel0 = classes["diceSetLabel"]
export { _diceSetLabel0 as "diceSetLabel" }

const _rollToActive0 = classes["rollToActive"]
export { _rollToActive0 as "rollToActive" }

const _shared3dDiceImageWrapper0 = classes["shared3dDiceImageWrapper"]
export { _shared3dDiceImageWrapper0 as "shared3dDiceImageWrapper" }

const _dice0 = classes["dice"]
export { _dice0 as "dice" }

const _shared3dDiceContainer0 = classes["shared3dDiceContainer"]
export { _shared3dDiceContainer0 as "shared3dDiceContainer" }

const _buttonsWrapper0 = classes["buttonsWrapper"]
export { _buttonsWrapper0 as "buttonsWrapper" }

const _clearButton0 = classes["clearButton"]
export { _clearButton0 as "clearButton" }

const _shared3dDiceImageDisabled0 = classes["shared3dDiceImageDisabled"]
export { _shared3dDiceImageDisabled0 as "shared3dDiceImageDisabled" }

const _wrapper0 = classes["wrapper"]
export { _wrapper0 as "wrapper" }

const _rollToWrapper0 = classes["rollToWrapper"]
export { _rollToWrapper0 as "rollToWrapper" }

const _rollToLabel0 = classes["rollToLabel"]
export { _rollToLabel0 as "rollToLabel" }

const _rollToContainer0 = classes["rollToContainer"]
export { _rollToContainer0 as "rollToContainer" }

const _plus0 = classes["plus"]
export { _plus0 as "plus" }

const _gear0 = classes["gear"]
export { _gear0 as "gear" }

const _shared3dDiceImage0 = classes["shared3dDiceImage"]
export { _shared3dDiceImage0 as "shared3dDiceImage" }

const _d1000 = classes["d100"]
export { _d1000 as "d100" }

const _rollButton0 = classes["rollButton"]
export { _rollButton0 as "rollButton" }

const _diceTextContainer0 = classes["diceTextContainer"]
export { _diceTextContainer0 as "diceTextContainer" }

const _changeDiceSetLink0 = classes["changeDiceSetLink"]
export { _changeDiceSetLink0 as "changeDiceSetLink" }

const _settingsButtonContainer0 = classes["settingsButtonContainer"]
export { _settingsButtonContainer0 as "settingsButtonContainer" }

const _diceContainer0 = classes["diceContainer"]
export { _diceContainer0 as "diceContainer" }

const _rollToButton0 = classes["rollToButton"]
export { _rollToButton0 as "rollToButton" }

const _die0 = classes["die"]
export { _die0 as "die" }
